import {BaseLink} from "react-router5";

export const PostContent = ({router,post,isListItem, children}) =>{

    if(isListItem){
        return <BaseLink router={router}  routeName="post" routeParams={{id: post.id}} >
            {children}
        </BaseLink>
    }

    return <div>
        {children}
    </div>
}